import React, { useState, useEffect } from 'react';
import "../../../Adm/Gerenciar/Prefeitura/GerenciarPrefeitura.css";
import { Button, message, Modal, Table, Space, DatePicker } from 'antd';
import { EditOutlined, EyeOutlined, PoweroffOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import dayjs from 'dayjs';
import { FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import api from '../../../../services/api';
import API_CONFIG from '../../../../config/api.config';

const GerenciarUsuario = () => {
  const [isMenuExpanded, setIsMenuExpanded] = useState(false);
  const navigate = useNavigate();
  const [usuarios, setUsuarios] = useState([]);
  const [usuariosOriginais, setUsuariosOriginais] = useState([]);
  const [modalDetalhesVisivel, setModalDetalhesVisivel] = useState(false);
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);
  const [usuarioSelecionadoFiltro, setUsuarioSelecionadoFiltro] = useState(null);
  const [loading, setLoading] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 600 });

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 8,
    total: 0
  });

  const [usuariosParaSelect, setUsuariosParaSelect] = useState([
    {
      value: null,
      label: 'Selecione o Usuário'
    }
  ]);

  useEffect(() => {
    carregarUsuarios();
  }, []);

  const carregarUsuarios = async () => {
    try {
      setLoading(true);
      const response = await api.get('/api/usuarios');
      
      if (response.data.status) {
        const usuariosData = response.data.usuarios || [];
        
        const usuariosFormatados = usuariosData.map(user => ({
          id: user.USU_ID,
          nome: user.USU_NOME,
          dataCadastro: user.USU_DATA_VINCULACAO,
          status: user.USU_STATUS === 'ATIVO' ? 'Ativo' : 'Inativo',
          tipo: user.USU_TIPO,
          login: user.USU_LOGIN,
          telefone: user.USU_TELEFONE
        }));

        setUsuarios(usuariosFormatados);
        setUsuariosOriginais(usuariosFormatados);
        setPagination({
          current: 1,
          pageSize: 10,
          total: usuariosData.length
        });

        const usuariosSelect = [
          {
            value: null,
            label: 'Selecione o Usuário'
          },
          ...usuariosData.map(user => ({
            value: user.USU_ID,
            label: user.USU_NOME
          }))
        ];
        setUsuariosParaSelect(usuariosSelect);
      } else {
        message.error('Erro ao carregar usuários');
      }
    } catch (error) {
     // console.error('Erro ao carregar usuários:', error);
      message.error('Erro ao carregar usuários');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleMenuChange = (event) => {
      setIsMenuExpanded(!event.detail.isCollapsed);
    };
    window.addEventListener('menuStateChange', handleMenuChange);
    return () => window.removeEventListener('menuStateChange', handleMenuChange);
  }, []);

  const handleFiltrarUsuario = (idSelecionado) => {
    setUsuarioSelecionadoFiltro(idSelecionado);
    if (!idSelecionado) {
      setUsuarios(usuariosOriginais);
    } else {
      setUsuarios(usuariosOriginais.filter(u => u.id === idSelecionado));
    }
  };

  const handleVisualizar = async (usuario) => {
    try {
      const response = await api.get(API_CONFIG.ENDPOINTS.USUARIOS.CONSULTAR_USUARIO(usuario.id));
      
      if (response.data.status) {
        const usuarioDetalhado = response.data.usuario;
        
        if (!usuarioDetalhado) {
          message.error('Usuário não encontrado');
          return;
        }

        //console.log('Dados do usuário:', usuarioDetalhado); // Para debug

        setUsuarioSelecionado({
          id: usuarioDetalhado.USU_ID,
          nome: usuarioDetalhado.USU_NOME,
          dataCadastro: usuarioDetalhado.USU_DATA_VINCULACAO,
          status: usuarioDetalhado.USU_STATUS === 'ATIVO' ? 'Ativo' : 'Inativo',
          tipo: usuarioDetalhado.USU_TIPO || 'Não informado',
          login: usuarioDetalhado.USU_LOGIN,
          telefone: usuarioDetalhado.USU_TELEFONE || 'Não informado'
        });
        setModalDetalhesVisivel(true);
      } else {
        message.error('Erro ao carregar detalhes do usuário');
      }
    } catch (error) {
     // console.error('Erro ao carregar detalhes do usuário:', error);
      message.error('Erro ao carregar detalhes do usuário');
    }
  };

  const handleEditar = (usuario) => {
    navigate(`/adm/editar-usuario/${usuario.id}`, { state: { usuario } });
  };

  const handleStatus = async (usuario) => {
    try {
      const novoStatus = usuario.status === 'Ativo' ? 'INATIVO' : 'ATIVO';
      
      const response = await api.put(API_CONFIG.ENDPOINTS.USUARIOS.ATUALIZAR_USUARIO(usuario.id), {
        USU_STATUS: novoStatus
      });

      if (response.data.status) {
        message.success(`Status do usuário alterado para ${novoStatus === 'ATIVO' ? 'Ativo' : 'Inativo'}`);
        carregarUsuarios(); // Recarrega a lista
      } else {
        message.error('Erro ao alterar status do usuário');
      }
    } catch (error) {
     // console.error('Erro ao alterar status do usuário:', error);
      message.error('Erro ao alterar status do usuário');
    }
  };

  const handleVoltar = () => {
    navigate('/adm');
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80
    },
    {
      title: 'Nome',
      dataIndex: 'nome',
      key: 'nome',
    },
    {
      title: 'Login',
      dataIndex: 'login',
      key: 'login',
    },
    {
      title: 'Tipo',
      dataIndex: 'tipo',
      key: 'tipo',
    },
    {
      title: 'Data de Cadastro',
      dataIndex: 'dataCadastro',
      key: 'dataCadastro',
      width: 180,
      render: (data) => dayjs(data).format('DD/MM/YYYY')
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 120,
      render: (status) => (
        <span style={{
          color: status === 'Ativo' ? '#008026' : '#ff4d4f',
          fontWeight: 500
        }}>
          {status}
        </span>
      )
    },
    {
      title: 'Ações',
      key: 'acoes',
      width: 200,
      render: (_, record) => (
        <Space>
          <Button
            type="primary"
            icon={<EyeOutlined />}
            onClick={() => handleVisualizar(record)}
            className="visualizar-btn"
          >
            Visualizar
          </Button>
          <Button
            icon={<EditOutlined />}
            onClick={() => handleEditar(record)}
          >
            Editar
          </Button>
          <Button
            icon={<PoweroffOutlined />}
            onClick={() => handleStatus(record)}
            danger={record.status === 'Ativo'}
          >
            {record.status === 'Ativo' ? 'Inativar' : 'Ativar'}
          </Button>
        </Space>
      )
    }
  ];

  return (
    <div className={`home-container ${isMenuExpanded ? 'menu-expanded' : ''}`}>
      <div className="modal-wrapper">
        <h1 className="modal-title">Gerenciar Usuários</h1>
        <div className="modal-content">
          <div className="search-container" style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', flexWrap: 'wrap' }}>
            <FormControl
              fullWidth
              size="small"
              variant="outlined"
              style={{ marginBottom: 8, minWidth: 200 }}
            >
              <InputLabel id="select-usuario-label">Selecione o Usuário</InputLabel>
              <Select
                labelId="select-usuario-label"
                value={usuarioSelecionadoFiltro}
                label="Selecione o Usuário"
                onChange={(e) => handleFiltrarUsuario(e.target.value)}
                disabled={loading}
              >
                {usuariosParaSelect.map(user => (
                  <MenuItem key={user.value || 'null'} value={user.value}>
                    {user.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              type="primary"
              onClick={handleFiltrarUsuario}
              className="search-button"
              style={{
                marginLeft: 4,
                marginBottom: 8,
                backgroundColor: '#001f4d',
                border: 'none',
                fontWeight: 500
              }}
              loading={loading}
            >
              BUSCAR
            </Button>
          </div>


          {/* Tabela responsiva */}
          {isMobile ? (
            <div className="tabela-mobile">
              {usuarios.map((item) => (
                <div className="tabela-mobile-item" key={item.id}>
                  <div className="item-nome">{item.nome}</div>
                  <div className="item-quantidade">Status: {item.status}</div>
                  <div className="item-descricao">Cargo: {item.cargo}</div>
                  <div className="item-botoes">
                    <Button size="small" onClick={() => handleVisualizar(item)} className="visualizar-btn" loading={loading}>Visualizar</Button>
                    <Button size="small" onClick={() => handleEditar(item)} disabled={loading}>Editar</Button>
                    <Button size="small" danger={item.status === 'Ativo'} onClick={() => handleStatus(item)} loading={loading}>
                      {item.status === 'Ativo' ? 'Inativar' : 'Ativar'}
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <Table
              columns={columns}
              dataSource={usuarios}
              rowKey="id"
              pagination={pagination}
              className="tabela-solicitacao"
              loading={loading}
            />
          )}
        </div>

        <Modal
          title="Detalhes do Usuário"
          open={modalDetalhesVisivel}
          onCancel={() => {
            setModalDetalhesVisivel(false);
            setUsuarioSelecionado(null);
          }}
          footer={[
            <Button 
              key="fechar" 
              onClick={() => {
                setModalDetalhesVisivel(false);
                setUsuarioSelecionado(null);
              }}
            >
              Fechar
            </Button>
          ]}
          width={800}
          styles={{
            body: {
              maxHeight: '70vh',
              overflowY: 'auto',
              padding: '24px'
            }
          }}
          destroyOnClose={true}
        >
          {usuarioSelecionado && (
            <div className="detalhe-expandido-item" style={{ margin: 0, flex: 1, overflowY: 'auto' }}>
              <div className="col-esq">
                <div>
                  <span className="label-icone">Nome:</span>
                  <div className="valor-destaque">{usuarioSelecionado.nome}</div>
                </div>
                <div>
                  <span className="label-icone">Tipo:</span>
                  <div className="valor-destaque">{usuarioSelecionado.tipo}</div>
                </div>
                <div>
                  <span className="label-icone">Status:</span>
                  <div className="valor-destaque">{usuarioSelecionado.status}</div>
                </div>
              </div>
              <div className="col-dir">
                {/*<div>
                  <span className="label-icone">Login:</span>
                  <div className="valor-destaque">{usuarioSelecionado.login}</div>
                </div>*/}
                <div>
                  <span className="label-icone">Telefone:</span>
                  <div className="valor-destaque">{usuarioSelecionado.telefone}</div>
                </div>
                <div>
                  <span className="label-icone">Data de cadastro:</span>
                  <div className="valor-destaque">{dayjs(usuarioSelecionado.dataCadastro).format('DD/MM/YYYY')}</div>
                </div>
              </div>
            </div>
          )}
        </Modal>
      </div>
    </div>
  );
};

export default GerenciarUsuario; 